module.exports = __webpack_public_path__ + "static/media/DSC04772.63d29870.png";